module.exports = __webpack_public_path__ + "media/images/front/icon_check_02-f17d922851cfdb14e4bfff9e2cda9abd.svg";